export class Card {
    cardId: string
    listId: string
    personId: string
    position: string
    userId: string
    status: number
    title: string
    text?: string
    scheduledAt?: Date
    createdAt: Date
}
